import defaultReducer from "@/redux/modules/default.reducer";
import { TApiAction } from "@/redux/store.types";

import { TBoxCounterState } from "./boxCount.types";

const discriminatorReducer = (
    state: TBoxCounterState,
    action: TApiAction,
    constants: any,
    options: any,
    initialState: any
) => {
    const { type, payload, actionOptions = {} } = action;

    let newState = { ...state };

    if (type === constants.RESET) {
        newState = {
            ...initialState,
            [actionOptions.discriminator!]: {}
        };
    }

    if (type === constants.PENDING) {
        newState = {
            ...state,
            [actionOptions.discriminator!]: {
                ...state[actionOptions.discriminator!],
                params: payload,
                error: null,
                data: options.clearOnFetch
                    ? null
                    : state[actionOptions.discriminator!]?.data
            }
        };
    }

    const skipSuccessData = actionOptions?.skipSuccessData
        ? actionOptions.skipSuccessData()
        : false;

    if (type === constants.SUCCESS) {
        newState = {
            ...state,
            [actionOptions.discriminator!]: {
                ...state[actionOptions.discriminator!],
                error: null,
                data: skipSuccessData
                    ? state[actionOptions.discriminator!]?.data
                    : payload
            }
        };
    }

    if (type === constants.FAILURE) {
        newState = {
            ...state,
            [actionOptions.discriminator!]: {
                ...state[actionOptions.discriminator!],
                error: payload,
                data: options.clearOnError
                    ? null
                    : state[actionOptions.discriminator!]?.data
            }
        };
    }

    return newState;
};

const BoxReducer = (
    state: any,
    action: TApiAction,
    constants: any,
    options: any,
    initialState: any
) => {
    const { actionOptions = {} } = action;

    const hasDiscriminator = !!actionOptions?.discriminator;

    return hasDiscriminator
        ? discriminatorReducer(state, action, constants, options, initialState)
        : defaultReducer(state, action, constants, options, initialState);
};

export default BoxReducer;
